export default __webpack_public_path__ + "static/auto-layout-do-dark-f6e0d6c6f63e14c5fd2d9b53fa742db2.png";